import { render, staticRenderFns } from "./RegText.vue?vue&type=template&id=cb2e1e5c"
import script from "./RegText.vue?vue&type=script&lang=js"
export * from "./RegText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports